import { PortalVService } from "../../services/V2/padre"
import { useMediaQuery, useTheme } from '@mui/material';

export const canAcceptCC = (paymentInfo) => {
    return paymentInfo.cc?.allowPayment
}
export const canAcceptAch = (paymentInfo) => {
    return paymentInfo.ach?.allowPayment
}
export const canAcceptAnything = (paymentInfo) => {
    return canAcceptAch(paymentInfo) || canAcceptCC(paymentInfo)
}

export const formatMoney = (money) => {
    //this will allow us to change formatting if we need foreign currency.
    var formatter = new Intl.NumberFormat('en-US', {// undefined uses system locale
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(money);
}

export function dateToLocal(dateString): Date {//right now all dates are UTC but look local in app. would be best to do this all at once
    var substring = dateString.toString().substring(0, 19);
    var year = parseInt(substring.substring(0,4));
    var month = parseInt(substring.substring(5,7)) - 1;
    var day = parseInt(substring.substring(8,10));
    var hour = parseInt(substring.substring(11,13) === "" ? 0 : substring.substring(11,13));
    var minute = parseInt(substring.substring(14,16) === "" ? 0 : substring.substring(14,16));
    var second = parseInt(substring.substring(17) === "" ? 0 : substring.substring(17));
    return new Date(Date.UTC(year, month, day, hour, minute, second));
}

export function dateToUTC(dateString: Date): string {
    return dateString.toUTCString();
}

export const handleChange = (event, model, setModel) => {
    let name = event.target.name;
    let value = event.target.value;

    if (event.target.type === "checkbox") {
        name = event.target.id;
        value = event.target.checked
    }
    setModel({
        ...model,
        [name]: value
    })
}

export const trimField = (event, model, setModel) => {
    let name = event.target.name;
    let value = event.target.value.trim();

    let filteredValue = value.replace(/[\u00AD]/g, '');

    setModel({
        ...model,
        [name]: filteredValue
    })
}

export const handlePhoneChange = (event, model, setModel) => {
    let name = event.target.name;
    let name2 = event.target.name + "Mask";
    let value = event.target.value.replace(/\D/g,'');;
    let value2 = event.target.value;
    setModel({
        ...model,
        [name]: value,
        [name2]: value2
    })
}

export function storeData(title: string, data: any) {
    sessionStorage.setItem(title, JSON.stringify(data));
}

export function retrieveData(title: string): any {
    let dataString = sessionStorage.getItem(title);
    return dataString ? JSON.parse(dataString) : null;
}

export function removeData(title: string) {
    sessionStorage.removeItem(title);
}

export async function getOperatorConfigs() {
    var href = window.location.href
    var url = href.split('/')[2];
    if(url === "localhost:3000") url = "rocketpack-test.avr-cloud.com";
    //if(url === "localhost:3000") url = "demo-rocketpack.i3verticals.cloud";
    var shortUrl = process.env.REACT_APP_ENV_NAME === "Demo" ? url.split('.i3verticals.cloud')[0] : url.split('.avr-cloud.com')[0];
    return await PortalVService.portalVGetOperatorConfigs(shortUrl);
}

export async function getOperatorId(){
    var refresh = retrieveData("refreshTimer");
    var id = retrieveData("operatorId");
    if(refresh === null || refresh < Date.now || id === null){
        await getOperatorConfigs()
            .then(x => {
                setConfigs(x)
                id = x.operatorId
            }).catch(e => console.log(e))
    }
    return new Promise(resolve => {
        resolve(id)
    })
}

export async function getLogo(){
    var refresh = retrieveData("refreshTimer");
    var logo = retrieveData("logoUrl");
    if(refresh === null || refresh < Date.now || logo === null){
        await getOperatorConfigs()
            .then(x => {
                setConfigs(x)
                logo = x.logoUrl
            }).catch(e => console.log(e))
    }
    return new Promise(resolve => {
        resolve(logo)
    })
}

export async function getImage(){
    var refresh = retrieveData("refreshTimer");
    var img = retrieveData("imageUrl");
    if(refresh === null || refresh < Date.now || img === null){
        await getOperatorConfigs()
            .then(x => {
                setConfigs(x)
                img = x.backgroundUrl
            }).catch(e => console.log(e))
    }
    return new Promise(resolve => {
        resolve(img)
    })
}

export async function getGuestPayment(): Promise<boolean> {
    var refresh = retrieveData("refreshTimer");
    var allowGuestPayments = retrieveData("guestPayment");
    if(refresh === null || refresh < Date.now || allowGuestPayments === null){
        await getOperatorConfigs()
            .then(x => {
                setConfigs(x)
                allowGuestPayments = x.allowGuestPayments
            }).catch(e => console.log(e))
    }
    return new Promise(resolve => {
        resolve(allowGuestPayments)
    })
}

export async function getColors(){
    var refresh = retrieveData("refreshTimer");
    var colors = {
        primary: retrieveData("primary"),
        secondary: retrieveData("secondary"),
        tertiary: retrieveData("tertiary")
    };
    if(refresh === null || refresh < Date.now){
        await getOperatorConfigs()
            .then(x => {
                setConfigs(x)
                colors = {
                    primary: x.primary,
                    secondary: x.secondary,
                    tertiary: x.tertiary
                }
            }).catch(e => console.log(e))
    }
    return new Promise(resolve => {
        resolve(colors)
    })
}
export async function getCustomerEdit(){
    var refresh = retrieveData("refreshTimer");
    var customerEdit = retrieveData("customerEdit");
    if(refresh === null || refresh < Date.now || customerEdit === null){
        await getOperatorConfigs()
            .then(x => {
                setConfigs(x)
                customerEdit = x.allowCustomerEdit
            }).catch(e => console.log(e))
    }
    return new Promise(resolve => {
        resolve(customerEdit)
    })
}

export function setConfigs(x){
    var timer = new Date(Date.now());
    timer.setHours(timer.getHours() + 12);
    storeData("operatorId", x.operatorId)
    storeData("logoUrl", x.logoUrl)
    storeData("primary", x.primary)
    storeData("secondary", x.secondary)
    storeData("tertiary", x.tertiary)
    storeData("refreshTimer", timer)
    storeData("customerEdit", x.allowCustomerEdit)
}

export const handleError = (apiError) => {
    try{
        var errorBody = JSON.parse(apiError.body)
        var errors = errorBody.errors
        if(errors) {
            return Object.keys(errors).map(errorKey => {
                return errors[errorKey].join('\n');
            }).join('\n')
        } else {
            return apiError.body.Message
        }
    }
    catch{
        return apiError.body.Message
    }
}

export const isProd = () => {
    const env = process.env.REACT_APP_ENV_NAME?.toLowerCase();
    return env === "production";
}

export function getURL() {
    var href = window.location.href
    return `https://${href.split('/')[2]}`;
}

export function convertPhoneNumber(number) {
    if(!number) return ""
    return number.replace(/[^\d]/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "($1)$2-$3");
}

export const IsMobile = () => {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down("md"));
    return mobile === true;
}

export function checkExpirationDate(expMonth, expYear) {
    const today = new Date();
    if (expYear.toString().length === 2) {
        if (today.getFullYear() > (expYear + 2000)) {
            return "Expired";
        }

        else if (today.getFullYear() === (expYear + 2000) && today.getMonth()+1 > expMonth) {
            return "Expired";
        }

        else if (today.getFullYear() === (expYear + 2000) && today.getMonth()+1 === expMonth) {
            return "Expiring";
        }
        
        else {
            return "Good"
        };

    }

    else {
        if (today.getFullYear() > expYear) {
            return "Expired";
        }

        else if (today.getFullYear() === expYear && today.getMonth()+1 > expMonth) {
            return "Expired";
        }

        else if (today.getFullYear() === expYear && today.getMonth()+1 === expMonth) {
            return "Expiring";
        }
    
        else {
            return "Good"
        };
    }
}

export function checkPaymentAmount(amount, paymentMode, ccMaxAmount, ccMinAmount, achMaxAmount, achMinAmount, setHasError, setErrorMessage) {
    if (!amount) {
        setHasError(true)
        setErrorMessage(null)
    }
    else if (amount <= 0) {
        setHasError(true)
        setErrorMessage("Amount must be greater than zero")
    }
    else if (paymentMode === "CC") {
        if (amount > ccMaxAmount) {
            setHasError(true)
            setErrorMessage(`Credit card payment cannot be more than ${formatMoney(ccMaxAmount)}`)
        }
        else if (amount < ccMinAmount) {
            setHasError(true)
            setErrorMessage(`Credit card payment cannot be less than ${formatMoney(ccMinAmount)}`)
        }
        else {
            setHasError(false)
            setErrorMessage(null)
        }
    }
    else if (paymentMode === "ACH") {
        if (amount > achMaxAmount) {
            setHasError(true)
            setErrorMessage(`ACH payment cannot be more than ${formatMoney(achMaxAmount)}`)
        }
        else if (amount < achMinAmount) {
            setHasError(true)
            setErrorMessage(`ACH payment cannot be less than ${formatMoney(achMinAmount)}`)
        }
        else {
            setHasError(false)
            setErrorMessage(null)
        }
    }
    else {
        setHasError(false)
        setErrorMessage(null)
    }
}